module.exports = __webpack_public_path__ + "static/media/ad.2f0263e0.svg";